const React = require('react');
const {
  paramStore,
} = require('../../../../stores');
const withState = require('../../../../utils/withState');
const CaptionC = require('../../../dumb/Caption/C');
const Ripple = require('../../../dumb/Ripple');
const WithdrawalAccount = require('./Accounts');

const tab$ = paramStore('tab', 'withdrawalAccounts');

module.exports = withState(() => {
  return (state, props) => {
    return (
      <div className={props.className || ''}>
        <div className="layoutRow fhaB fvaC">
          <CaptionC>Management</CaptionC>
        </div>
        <div className="mt35 cfx mh-8 lisN">
          <div
            className="lt ph8 pb16 w1/5@d2 w1/4@d w1/3@m w1/2@m2 w@m3"
          >
            <div
              className={`rlv w dn o50.disabled
                (abs|sb-6|sl50%|x-50%|dn|cnt_|dB|bs|bcF0|b|bh10|bt7):after
                bct(5B47FF|4B37EF:not[.disabled]:h).active:after active`}
            >
              <Ripple
                className="w layoutRow fhaC fvaC h82 usN bgF6F6F6
                bgE6E6E6:not[.disabled]:h
                r9 ov ttU olN tdN lts0em fw7 f12 lh18 tc p10 dn
                (cF|bg(5B47FF|4B37EF:not[.disabled]:h!))<1.active"
              >
                Crypto<br/>accounts
              </Ripple>
            </div>
          </div>
        </div>
        <div className="mt14">
          <WithdrawalAccount />
        </div>
      </div>
    );
  };
}, {
  currentTab: tab$,
});
